import * as React from 'react';

import type { ClickAutocompleteSuggestions, SuggestionState } from '@coursera/event-pulse-types';
import { useVisibilityTracker } from '@coursera/event-pulse/react';

import { AiPromptPill } from 'bundles/search-common/components/AiPromptPill';
import {
  ASK_ANYTHING_AI_PROMPT_ID,
  ASK_ANYTHING_ROUTE_TYPE,
} from 'bundles/search-common/components/experiments/aiSearchOnLohp/constants';
import { AUTOCOMPLETE_PREFIX_DELIMITER } from 'bundles/search-common/constants/autocomplete';

type Props = {
  id: string;
  name: string;
  routeType?: string;
  intentType?: string;
  routeParameter?: string;
  suggestionIndex?: number;
  groupId?: string;
  suggestionState?: SuggestionState;
  disabled?: boolean;
};

const AutocompleteAiPromptOption = ({
  id,
  name,
  routeType,
  intentType,
  routeParameter,
  suggestionIndex,
  groupId,
  suggestionState = 'zero_state',
  disabled = false,
}: Props) => {
  const isAskAnything = id === ASK_ANYTHING_AI_PROMPT_ID || routeType === ASK_ANYTHING_ROUTE_TYPE;

  // Strip the autocomplete section prefix (e.g. "aiPromptsZeroState~") from the id
  const promptId = id.includes(AUTOCOMPLETE_PREFIX_DELIMITER)
    ? id.split(AUTOCOMPLETE_PREFIX_DELIMITER).pop() ?? id
    : id;

  const eventingData: ClickAutocompleteSuggestions = {
    page: {},
    queryPrompt: {
      id: promptId,
      location: 'autocomplete',
      promptText: name,
      intentType,
      routeType,
      routeParameter,
    },
    suggestionType: 'ai_prompt',
    suggestionSection: 'ai_prompt',
    suggestionState,
    suggestionIndex,
  };

  const trackingRef: React.MutableRefObject<HTMLSpanElement | null> = useVisibilityTracker(
    'view_autocomplete_suggestions',
    eventingData,
    [],
    { fullyVisible: true, initialDelay: 1000 }
  );

  return (
    <span ref={trackingRef} data-group={groupId}>
      <AiPromptPill label={name} size="small" variant={isAskAnything ? 'alive' : 'white'} disabled={disabled} />
    </span>
  );
};

export default AutocompleteAiPromptOption;
